import { render } from "./editeStockAlloction.vue?vue&type=template&id=37116304"
import script from "./editeStockAlloction.vue?vue&type=script&lang=js"
export * from "./editeStockAlloction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__